import Axios from "axios";

export default function SendForgotEmail(email){
    let response = Axios.get(process.env.REACT_APP_GATEWAY_URL, {
        params: {
            a: 'sendForgotEmail',
           email
        }
        
    });
    return response;
}